export const enum RoleType {
    BUYER = 'Buyer',
    ARTIST = 'Artist',
}